import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../../../UI Design/Contact.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [message, setMessage] = useState('');

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    const serviceId = 'service_althafcontact';
    const templateId = 'template_lwp73w9';
    const publicKey = 'KqGoNwXnirJM_ZX2r';

    const templateParams = {
      from_name: name,
      from_email: email,
      email_subject: emailSubject,
      mobile_no: mobileNumber,
      to_name: 'Althaf Hussain',
      message: message,
    };

    emailjs.send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log('Email sent Successfully!', response);
        setName(templateParams.from_name);
        setEmail(templateParams.from_email);
        setEmailSubject(templateParams.email_subject);
        setMobileNumber(templateParams.mobile_no);
        setMessage(templateParams.message);
        toast.success('Email sent successfully!', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });


        e.target.reset();
        setName('');
        setEmail('');
        setEmailSubject('');
        setMessage('');
        setMobileNumber('');

      })
      .catch((error) => {
        console.error('Error sending email:', error);
        toast.error('Error sending email. Please try again.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });

  };

  return (
    <div className='contact' id='contact'>
      <h2 className='heading'>Contact <span>Me!</span></h2>

      <form ref={form} onSubmit={sendEmail}>
        <div className="input-box">
          <input type='text' name='name' value={name} onChange={(e) => setName(e.target.value)} placeholder='Full Name' required></input>
          <input type='email' name='email' placeholder='Email Address' value={email} onChange={(e) => setEmail(e.target.value)} required></input>
        </div>
        <div className="input-box">
          <input type='number' name='mobile' value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} placeholder='Mobile Number' required></input>
          <input type='text' name='subject' value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} placeholder='Email Subject' required></input>
        </div>
        <textarea name='message' cols='30' rows='10' value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Your Message' required></textarea>
        <input type='submit' value='Send Message' className='btn'></input>
      </form>
      <ToastContainer />
    </div>
  );
}
